import { api } from '@/lib/api';

export interface PropertyContactNumber {
  number: string;
  whatsappEnabled: boolean;
}

export interface PropertyNotificationSettings {
  bookingAlerts: boolean;
  checkinReminders: boolean;
  checkoutReminders: boolean;
  paymentDue: boolean;
  housekeepingAlerts: boolean;
}

export interface PropertyProfile {
  id: string;
  key: string;
  name: string;
  tagline: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  phone: string;
  whatsappNumber: string;
  contactNumbers: PropertyContactNumber[];
  email: string;
  logoUrl: string;
  buildingImages: Record<string, string>;
  mapsUrl: string;
  latitude: number | null;
  longitude: number | null;
  bankAccountName: string;
  bankName: string;
  bankAccountNumber: string;
  currency: string;
  checkInTime: string;
  checkOutTime: string;
  lateCheckoutFeeMinorUnits: number;
  lateCheckoutGraceMinutes: number;
  defaultLanguage: string;
  autoAssignRooms: boolean;
  notificationSettings: PropertyNotificationSettings;
  totalRooms: number;
  totalFloors: number;
  updatedAt: string;
}

let cached: PropertyProfile | null = null;
let pending: Promise<PropertyProfile> | null = null;

export const propertyProfileService = {
  async get(force = false): Promise<PropertyProfile> {
    if (!force && cached) return cached;
    if (!force && pending) return pending;
    pending = api
      .get<PropertyProfile>('/property-profile', { auth: false })
      .then((profile) => {
        cached = profile;
        return profile;
      })
      .finally(() => {
        pending = null;
      });
    return pending;
  },

  async update(input: Partial<PropertyProfile>): Promise<PropertyProfile> {
    const profile = await api.patch<PropertyProfile>('/property-profile', input);
    cached = profile;
    return profile;
  },
};
